import { ITitleTextButton } from './types';
import { RichText } from 'prismic-reactjs';
import CustomPrismicLink from '@components/CustomPrismicLink';
import HyperLink from '@monofront/design-system/components/HyperLink';
import withSlice from '@screens/SlicesContainer/withSlice';
import { mapTitleTextButton } from './mapTitleTextButton';

const TitleTextButton: React.FC<ITitleTextButton> = ({
  buttonLabel,
  link,
  text,
  title,
}) => {
  return (
    <div className="approach">
      <div className="title">
        <RichText render={title} />
      </div>
      <div className="text">
        <RichText render={text} serializeHyperlink={CustomPrismicLink} />
      </div>
      <div className="cta-button">
        <HyperLink variant="button-primary" to={link}>
          {buttonLabel}
        </HyperLink>
      </div>
      <style jsx>{`
        .approach {
          text-align: center;
        }

        .approach :global(h1) {
          margin-bottom: var(--space-4);
        }

        .title,
        .text {
          margin-bottom: var(--space-4);
        }

        .cta-button {
          display: flex;
          justify-content: center;
        }
      `}</style>
    </div>
  );
};

export default withSlice(TitleTextButton, mapTitleTextButton);
